import { ITemplateStylingSettings } from '@/components/settings-page/platformSettings/templatesSettings/types';
import { IDocumentRecordTemplate } from '@/shared/types/templates/documentRecordTemplate';
import * as docx from 'docx';
import { DefaultTheme } from 'styled-components/dist/types';
import { getOneColumnSection } from './components/sections/oneColumnSection';
import { createInvestmentParagraphsForDOCX } from './utils';

export const formattingDocumentRecordDataForDocx = async (
  templateData: IDocumentRecordTemplate[],
  templateStylingData: ITemplateStylingSettings,
  includeAiSuggested: boolean,
  theme: DefaultTheme
) => {
  const headerFontColor = templateStylingData?.headerFontStyle?.fontColor ? `#${templateStylingData?.headerFontStyle?.fontColor}` : theme.font.strong;
  const accentColor = templateStylingData?.accentColor || '#5A6771';

  let docxData = [];

  for await (const item of templateData) {
    docxData.push(new docx.Paragraph({ pageBreakBefore: true }));
    docxData.push(
      ...createInvestmentParagraphsForDOCX({
        investmentName: item.investmentName,
        templateName: item.updateName,
        investmentDescription: item.investmentDescription,
        headerFontColor,
        theme
      })
    );
    const sectionData = await getOneColumnSection(item.fields, includeAiSuggested, theme, headerFontColor, accentColor);
    docxData.push(...sectionData);
  }

  return docxData;
};
